import * as React from 'react';
import { useContext, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import Link from '../../../Link';
import ResendTicketsForm from '../../../ResendTicketsForm/components/ResendTicketsForm';
import { ResendTicketsStages } from '../../../ResendTicketsForm/types';
import { OrderCardContext } from '../OrderCard';
import { useResendTickets } from '../../../Checkout/components/Checkout/hooks';
import { hideText } from '../../../Passenger/utils';
import CommonItem from '../CommonItem/CommonItem';
import ModalConfirm from '../../../ModalConfirm';
import { getUserValue } from '../../../utils';
import { TravellerFieldEnum } from '@websky/graphql';
import WarningModal from '../../../WarningModal';
const OrderTickets = props => {
    const { t } = useTranslation('OrderCard');
    const { OrderTickets: css } = useTheme('OrderCard');
    const { order } = useContext(OrderCardContext);
    const email = useMemo(() => getUserValue(order.customer, TravellerFieldEnum.Email), [order.id]);
    const { resendStage, handleWarningModalClose, handleResendEmail, isModalOpen, isUnauthorizedError, closeModal, openModal } = useResendTickets(order.id);
    const submitRef = useRef();
    const isLoading = resendStage === ResendTicketsStages.Loading;
    return (React.createElement(React.Fragment, null,
        React.createElement(CommonItem, { icon: 'Action/Send Mail', text: t(!email ? 'Send tickets to the email?' : 'Tickets have been sent to {{email}}', {
                email: hideText(email)
            }), className: cn(css.wrapper, props.className), buttons: React.createElement(Link, { className: css.link, action: openModal }, t('Resend it')) }),
        React.createElement(ModalConfirm, { isOpen: isModalOpen, onClose: closeModal, ignoreClose: isLoading, title: t('Send all documents to email'), cancelBtn: t('Cancel'), confirmBtn: t('Send'), isLoading: isLoading, onConfirm: () => { var _a; return (_a = submitRef.current) === null || _a === void 0 ? void 0 : _a.call(submitRef); }, onCancel: closeModal },
            React.createElement(ResendTicketsForm, { defaultEmail: email, onSubmit: ({ email }) => handleResendEmail(email), submitRef: submitRef })),
        React.createElement(WarningModal, { isOpen: isUnauthorizedError, title: t('Error'), content: t('To submit documents, log in to your account or use the email provided during the booking.'), buttonText: t('Close'), onButtonClick: handleWarningModalClose, onClose: handleWarningModalClose })));
};
export default OrderTickets;
